"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyIframeResponseToJSON = exports.LoyaltyIframeResponseFromJSONTyped = exports.LoyaltyIframeResponseFromJSON = void 0;
function LoyaltyIframeResponseFromJSON(json) {
    return LoyaltyIframeResponseFromJSONTyped(json, false);
}
exports.LoyaltyIframeResponseFromJSON = LoyaltyIframeResponseFromJSON;
function LoyaltyIframeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iframeKey': json['iframeKey'],
    };
}
exports.LoyaltyIframeResponseFromJSONTyped = LoyaltyIframeResponseFromJSONTyped;
function LoyaltyIframeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iframeKey': value.iframeKey,
    };
}
exports.LoyaltyIframeResponseToJSON = LoyaltyIframeResponseToJSON;
//# sourceMappingURL=LoyaltyIframeResponse.js.map